import { render, staticRenderFns } from "./BannerInventarios.vue?vue&type=template&id=111ebc24&scoped=true"
import script from "./BannerInventarios.vue?vue&type=script&lang=js"
export * from "./BannerInventarios.vue?vue&type=script&lang=js"
import style0 from "./BannerInventarios.vue?vue&type=style&index=0&id=111ebc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111ebc24",
  null
  
)

export default component.exports